import { PAGE_TYPE } from "@/meta/common";
import { RouteRecordRaw } from "vue-router";
/**
 * 仓储管理
 */
export const warehouseStorageManageRouter: RouteRecordRaw[] = [
    {
        path: "warehouseManage",
        name: "WarehouseManage",
        component: () => import("@/views/layouts/index.vue"),
        redirect: "/warehouseManage/inventoryQuery",
        meta: {
            title: "仓储监管"
        },
        children: [
            {
                path: "inventoryQuery",
                name: "WarehouseManagementInventoryQuery",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/inventoryQuery/index.vue"),
                meta: {
                    title: "库存查询",
                    pageType: PAGE_TYPE.LIST.code,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_W_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_W_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "warehouseManagementDistribution/:id",
                name: "WarehouseManagementDistribution",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/inventoryQuery/distribution.vue"),
                meta: {
                    title: "库存分布",
                    pageType: PAGE_TYPE.DETAIL.code,
                    hidden: true,
                    activeMenu: "WarehouseManagementInventoryQuery",
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_W_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_W_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storeInbound",
                name: "StoreInbound",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/inboundManagement/index.vue"),
                meta: {
                    title: "入库管理",
                    activeMenu: "StoreInbound",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_W_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_W_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storeInbound/detail",
                name: "StoreInboundDetail",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/inboundManagement/detail.vue"),
                meta: {
                    title: "入库单详情",
                    activeMenu: "StoreInbound",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.DETAIL.code,
                    hidden: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_W_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_W_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storeInbound/add",
                name: "StoreInboundAdd",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/inboundManagement/form.vue"),
                meta: {
                    title: "新增入库单",
                    activeMenu: "StoreInbound",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storeInbound/edit",
                name: "StoreInboundEdit",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/inboundManagement/form.vue"),
                meta: {
                    title: "修改入库单",
                    activeMenu: "StoreInbound",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storeOutbound",
                name: "StoreOutbound",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/outboundManagement/index.vue"),
                meta: {
                    title: "出库管理",
                    isNotShowHeader: true,
                    activeMenu: "StoreOutbound",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_W_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_W_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storeOutbound/add",
                name: "StoreOutboundAdd",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/outboundManagement/form.vue"),
                meta: {
                    title: "新增出库单",
                    activeMenu: "StoreOutbound",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storeOutbound/edit",
                name: "StoreOutboundEdit",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/outboundManagement/form.vue"),
                meta: {
                    title: "修改出库单",
                    activeMenu: "StoreOutbound",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storeOutbound/detail",
                name: "StoreOutboundDetail",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/outboundManagement/detail.vue"),
                meta: {
                    title: "出库单详情",
                    activeMenu: "StoreOutbound",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.DETAIL.code,
                    hidden: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_W_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_W_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storeStocktaking",
                name: "StoreStocktaking",
                component: () =>
                    import("@/views/pages/warehouseManagement/storageManagement/storeStocktakingManagement/index.vue"),
                meta: {
                    title: "盘点管理",
                    keepAlive: true,
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_W_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_W_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storeStocktaking/detail",
                name: "StoreStocktakingDetail",
                component: () =>
                    import("@/views/pages/warehouseManagement/storageManagement/storeStocktakingManagement/detail.vue"),
                meta: {
                    title: "盘点详情",
                    activeMenu: "StoreStocktaking",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.DETAIL.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_W_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_W_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storeStocktaking/add",
                name: "StoreStocktakingAdd",
                component: () =>
                    import("@/views/pages/warehouseManagement/storageManagement/storeStocktakingManagement/form.vue"),
                meta: {
                    title: "新增盘点单",
                    activeMenu: "StoreStocktaking",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storeStocktaking/edit",
                name: "StoreStocktakingEdit",
                component: () =>
                    import("@/views/pages/warehouseManagement/storageManagement/storeStocktakingManagement/form.vue"),
                meta: {
                    title: "修改盘点单",
                    activeMenu: "StoreStocktaking",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storeRandomInspection",
                name: "StoreRandomInspection",
                component: () =>
                    import("@/views/pages/warehouseManagement/storageManagement/inventoryRandomInspection/index.vue"),
                meta: {
                    title: "库存抽检",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_W_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_W_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storeRandomInspection/detail/:id",
                name: "StoreRandomInspectionDetail",
                component: () =>
                    import("@/views/pages/warehouseManagement/storageManagement/inventoryRandomInspection/detail.vue"),
                meta: {
                    title: "抽检详情",
                    activeMenu: "StoreRandomInspection",
                    pageType: PAGE_TYPE.LOG.code,
                    hidden: true,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_W_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_W_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storeRandomInspection/add",
                name: "StoreRandomInspectionAdd",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/inventoryRandomInspection/form.vue"),
                meta: {
                    title: "新增抽检单",
                    activeMenu: "StoreRandomInspection",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storeRandomInspection/edit/:id",
                name: "StoreRandomInspectionEdit",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/inventoryRandomInspection/form.vue"),
                meta: {
                    title: "修改抽检单",
                    activeMenu: "StoreRandomInspection",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            // 质押管理
            {
                path: "storePledge",
                name: "StorePledgeManagement",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/pledgeManagement/index.vue"),
                meta: {
                    title: "质押管理",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_W_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_W_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storePledge/detail/:id",
                name: "StorePledgeDetail",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/pledgeManagement/detail.vue"),
                meta: {
                    title: "质押详情",
                    activeMenu: "StorePledgeManagement",
                    pageType: PAGE_TYPE.LOG.code,
                    hidden: true,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_W_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_W_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storePledge/add",
                name: "StorePledgeAdd",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/pledgeManagement/add.vue"),
                meta: {
                    title: "新增质押",
                    activeMenu: "StorePledgeManagement",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storePledge/edit/:id",
                name: "StorePledgeEdit",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/pledgeManagement/add.vue"),
                meta: {
                    title: "变更质押",
                    activeMenu: "StorePledgeManagement",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            // 仓储期初
            {
                path: "storeInception",
                name: "StoreInception",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/storageInception/index.vue"),
                meta: {
                    title: "仓储期初",
                    pageType: PAGE_TYPE.LIST.code,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_W_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_W_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storeInception/detail/:id",
                name: "StoreInceptionDetail",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/storageInception/detail.vue"),
                meta: {
                    title: "仓储期初详情",
                    activeMenu: "StoreInception",
                    pageType: PAGE_TYPE.LOG.code,
                    hidden: true,
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_W_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_W_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storeInception/add",
                name: "StoreInceptionAdd",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/storageInception/add.vue"),
                meta: {
                    title: "新增仓储期初",
                    activeMenu: "StoreInception",
                    isNotShowHeader: true,
                    hidden: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "storeInception/edit/:id",
                name: "StoreInceptionEdit",
                component: () => import("@/views/pages/warehouseManagement/storageManagement/storageInception/add.vue"),
                meta: {
                    title: "修改仓储期初",
                    activeMenu: "StoreInception",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            }
        ]
    }
];
